module.exports = __webpack_public_path__ + "ath_game_web/img/5.7.aad80b51.png";